import { BrowserImageCodec } from './image-codec';
import { PsdCodec } from './psd-codec';
import { MaipoDocumentCodec } from './maipo-codec';
import type { CodecContext, CodecReadResult, DocumentCodec } from './types';
import { SvgCodec } from './svg-codec';

export class CodecRegistry {
  private readonly codecs: DocumentCodec[] = [];

  register(codec: DocumentCodec): void {
    this.codecs.push(codec);
  }

  find(file: File): DocumentCodec | undefined {
    return this.codecs.find((codec) => codec.canRead(file));
  }

  async read(file: File, context?: CodecContext): Promise<CodecReadResult> {
    const codec = this.find(file);
    if (!codec) throw new Error(`“${file.name}” is not a supported image or Maipo project.`);
    const result = await codec.read(file, context);
    // Reports travel with the document so every import entry point and native
    // save/reopen retains the same compatibility disclosure.
    if (result.report) result.document.importReport = result.report;
    return result;
  }
}

export function createDefaultCodecRegistry(): CodecRegistry {
  const registry = new CodecRegistry();
  registry.register(new MaipoDocumentCodec());
  registry.register(new PsdCodec());
  // Before the image codec: image/svg+xml starts with "image/", so the browser
  // codec would otherwise claim an SVG and rasterise it through createImageBitmap.
  registry.register(new SvgCodec());
  registry.register(new BrowserImageCodec());
  return registry;
}
